import { NoData } from "neetoui";

const NoDataMessage = ({ message }) => (
  <div className="flex h-full min-h-screen items-center justify-center text-blue-700">
    <NoData title={message} />
  </div>
);

export default NoDataMessage;
